import CardNumber from "./Common/CardNumber";

const Requirements = () => (
  <>
    <div className="flex justify-start pt-16  pb-4 px-4 md:py-16 md:px-10 xl:pb-16 xl:px-32 xl:pt-0">
      <div className="w-1/2 md:pl-4 xl:pl-16">
        <CardNumber
          description="Challenges we figured out"
          number="02"
          title="REQUIREMENTS"
        />
      </div>
    </div>
    <div className="flex justify-end px-4 pb-8 md:pr-16 md:pb-0 md:pl-10 xl:pr-16 xl:pl-0 text-justify">
      <div className="w-full xl:w-8/12">
        <p className="text-base font-normal pt-8 md:pt-0 mb-4">
          <span className="font-josefin">
            The biggest challenge the client faced was finding a reliable
            technology partner. They felt stuck with an organization that could
            not understand their project needs or deliver quality work. They
            were looking for a team who could understand their needs, fix the
            broken code, and develop the new features and PWA to launch on a
            predefined event date.
          </span>
        </p>
        <p className="text-base font-normal pt-8 md:pt-0 mb-4">
          <span className="font-josefin">
            As an experienced team, ultroNeous took all the time required to
            understand the project flow, develop features, and upgrade the code
            standards. Getting their needs on paper was the most crucial step
            towards launching something extraordinary.
          </span>
        </p>
      </div>
    </div>
    <div className="flex justify-end px-4 pb-8 md:pr-16 md:pb-0 md:pl-10 xl:pr-16 xl:pl-0 text-justify">
      <div className="w-full xl:w-8/12">
        <div className="flex flex-col md:flex-row flex-wrap md:py-16">
          <div className="w-full md:w-1/2">
            <div className="pb-8 md:pr-8 md:pb-16">
              <h3 className="text-lg md:text-2xl xl:text-lg font-normal text-erie-black flex justify-start items-center">
                <span className="font-josefin">
                  <span className="border border-solid border-black text-white bg-black rounded-3xl py-1 px-2 text-xs mr-4">
                    1
                  </span>
                  A Scalable backend
                </span>
              </h3>
              <p className="text-base md:text-sm font-light text-erie-black ml-10">
                <span className="font-josefin">
                  Creating a clean database structure is required to meet the
                  application&apos;s current and future needs. And a back end to
                  take care of scalability.
                </span>
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2">
            <div className="pb-8 md:pr-8 md:pb-16">
              <h3 className="text-lg md:text-2xl xl:text-lg font-normal text-erie-black flex justify-start items-center">
                <span className="font-josefin">
                  <span className="border border-solid border-black text-white bg-black rounded-3xl py-1 px-2 text-xs mr-4">
                    2
                  </span>
                  A Stable App
                </span>
              </h3>
              <p className="text-base md:text-sm font-light text-erie-black ml-10">
                <span className="font-josefin">
                  Several requirements included improving code quality, fixing
                  broken features, and developing the remaining significant
                  features around NFC and Networking.
                </span>
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2">
            <div className="pb-8 md:pr-8 md:pb-16">
              <h3 className="text-lg md:text-2xl xl:text-lg font-normal text-erie-black flex justify-start items-center">
                <span className="font-josefin">
                  <span className="border border-solid border-black text-white bg-black rounded-3xl py-1 px-2 text-xs mr-4">
                    3
                  </span>
                  A Brand new PWA
                </span>
              </h3>
              <p className="text-base md:text-sm font-light text-erie-black ml-10">
                <span className="font-josefin">
                  The requirement was to develop a PWA concept that allows
                  people to connect with app users with a single tap without the
                  need to sign up.
                </span>
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2">
            <div className="pb-8 md:pr-8 md:pb-16">
              <h3 className="text-lg md:text-2xl xl:text-lg font-normal text-erie-black flex justify-start items-center">
                <span className="font-josefin">
                  <span className="border border-solid border-black text-white bg-black rounded-3xl py-1 px-2 text-xs mr-4">
                    4
                  </span>
                  A Timely Delivery
                </span>
              </h3>
              <p className="text-base md:text-sm font-light text-erie-black ml-10">
                <span className="font-josefin">
                  Timely delivery with the proper Quality check is required to
                  launch the product during an agreed launch event.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);
export default Requirements;
